<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/KnowledgeIndex/kManageIndex' }"
          >知识付费内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/KnowledgeIndex/kManageEdit/kVideoList' }"
          >内容视频链接</el-breadcrumb-item
        >
        <el-breadcrumb-item>内容视频链接设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>内容视频链接设置</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="form_item">
            <div class="block">
              <p><span class="mark">*</span>视频标签</p>
              <div class="textarea_box">
                <el-input
                  v-model="formData.videotopic"
                  placeholder="请输入视频标签"
                ></el-input>
              </div>
            </div>
          </div>
          <!-- 商品详情编辑内容 -->
          <div class="product_details_edit">
            <!-- 编辑内容展示 -->
            <div class="product_details_content" v-if="formData.videourl != ''">
              <div class="product_details_item">
                <!-- 子内容操作 -->
                <div class="product_details_item_operate flex-between">
                  <div class="txt">视频</div>
                  <div class="operate_group flex-rowr">
                    <div class="btn flex-rowc" @click="formData.videourl = ''">
                      移除
                    </div>
                  </div>
                </div>
                <div class="product_details_item_content">
                  <!-- 视频 -->
                  <div class="video_box">
                    <div @click="openFileInputVideo(item.id)">
                      <video :src="formData.videourl" controls></video>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 编辑操作 -->
            <div
              class="product_details_operate flex-between"
              v-if="formData.videourl == ''"
            >
              <div class="txt">内容</div>
              <div class="operate_group flex-rowr">
                <div class="btn flex-rowc" @click="openFileInputVideo('')">
                  + 新增视频内容
                </div>
              </div>
            </div>
            <input
              type="file"
              ref="fileInputVideo"
              style="display: none"
              @change="addVideoContent"
              accept="video/*"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getUploadToken, encryptstringview } from "../../../api/api";
import {
  getKonwledgeVideoDetail,
  editKonwledgeVideo,
  addKonwledgeVideo,
} from "../../../api/knowledge";
export default {
  name: "kVideoDetail",
  data() {
    return {
      formData: {
        id: "",
        kpid: "",
        videotopic: "",
        videourl: "",
      },

      loading: false,
      loadingText: "请稍后",
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, kpid } = JSON.parse(res.jsondata);
        console.log(id, kpid);
        this.formData.id = id;
        this.formData.kpid = kpid;
        if (id) {
          this.getDetail(id);
        }
      } else {
        this.$router.back();
      }
    },

    getDetail(id) {
      this.loading = true;
      getKonwledgeVideoDetail({ id }).then((res) => {
        this.formData.videotopic = res.videotopic ? res.videotopic : "";
        this.formData.videourl = res.videourl ? res.videourl : "";

        this.loading = false;
      });
    },

    /**
     * 编辑商品详情
     * **/
    // 3、新增视频内容
    openFileInputVideo(id) {
      this.editId = id;
      this.$refs.fileInputVideo.click();
    },
    addVideoContent(e) {
      this.loading = true;
      getUploadToken().then((res) => {
        var formData = new FormData();
        formData.append("name", "file");
        formData.append("key", res.key);
        formData.append("policy", res.policy);
        formData.append("OSSAccessKeyId", res.OSSAccessKeyId);
        formData.append("success_action_status", "200");
        formData.append("signature", res.signature);
        formData.append("file", e.target.files[0]);
        const config = {
          onUploadProgress: this.setUploadProgress, // 将方法绑定到上传进度事件上
        };
        return new Promise((resolve, reject) => {
          axios
            .post("https://upload.vwingist.com/", formData, config)
            .then((response) => {
              // 请求成功的处理
              if (response.status === 200) {
                resolve(response.data);
                let videourl = res.host + "/" + res.key;
                this.formData.videourl = videourl;
              } else {
                reject("请求失败");
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      });
    },
    // 设置上传进度
    setUploadProgress(event) {
      // 进度处理逻辑
      const progress = Math.round((event.loaded / event.total) * 100);
      this.loadingText = `上传:${progress}%`;
      if (progress == 100) {
        this.loading = false;
      }
    },

    handleReturn() {
      // history.back();
      this.$router.push({ name: "cManageIndex" });
    },

    query() {
      let { formData } = this;
      if (formData.videotopic == "") {
        this.$message.warning("请输入视频标题");
        return;
      }
      if (formData.videourl == "") {
        this.$message.warning("请上传视频");
        return;
      }
      console.log(formData, "====-=formData=====");
      this.loading = true;
      if (formData.id) {
        editKonwledgeVideo(formData).then((res) => {
          if (res.result) {
            this.loading = false;
            this.$message.success(res.message);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addKonwledgeVideo(formData).then((res) => {
          if (res.result) {
            this.loading = false;
            this.$message.success(res.message);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        .form_item {
          margin-bottom: 40px;
          .block {
            margin-bottom: 25px;
          }
        }
      }
    }
  }
  .product_details_edit {
    width: 100%;
    padding: 0 0 70px;
    font-size: 20px;
    color: #505050;
    .product_details_content {
      box-sizing: border-box;
      margin-bottom: 20px;
      .product_details_item {
        .product_details_item_operate {
          width: 100%;
          height: 50px;
          border: 1px solid #d2d2d2;
          font-size: 14px;
          padding: 0 22px;
          box-sizing: border-box;
          .txt {
            font-size: 16px;
          }
          .operate_group {
            .btn {
              border: 1px solid #d2d2d2;
              height: 25px;
              padding: 0 14px;
              margin-left: 20px;
              cursor: pointer;
              &.disable {
                color: #c1c1c1;
              }
            }
          }
        }
        .product_details_item_content {
          padding: 0 12px 40px;
          .txt_box {
            min-height: 150px;
            .van-cell {
              padding: 0;
            }
          }
          .pic_box,
          .video_box {
            padding-top: 25px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
    .product_details_operate {
      border: 1px solid #d2d2d2;
      padding: 15px 20px 20px;
      .txt {
        font-size: 16px;
        white-space: nowrap;
      }
      .btn {
        font-size: 14px;
        color: #ffffff;
        height: 30px;
        background: #1e1e1e;
        padding: 0 6px;
        white-space: nowrap;
        cursor: pointer;
        &:nth-child(2) {
          margin: 0 10px;
        }
      }
    }
  }
  .popup_add_wrap {
    font-size: 18px;
    .popup_add_content {
      .add_item {
        cursor: pointer;
        height: 70px;
        border-bottom: 2px solid #ededed;
        &:last-child {
          border-bottom: none;
        }
        .iconfont {
          font-size: 26px;
          margin-right: 10px;
        }
      }
    }
    .popup_add_cancle {
      height: 100px;
      border-top: 5px solid #ededed;
    }
  }
}
</style>